import clsx from 'clsx'
import styled from 'styled-components'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { fetcher as fetcherAPI } from '../../helpers/fetcher'
import { normalisedTimeFormat } from '../../helpers/helpers'
import { finalTranslations } from '../../localTranslation'
import { DataContext } from '../../store/GlobalState'
import WarningEditModal from '../WarningEditModal/index'
import { BlueBtn } from '../WriteEditScenarioForm'
import styles from './CardFooter.module.css'

const CardFooter = ({
  lang,
  onOpenPhenEditCard,
  canEditContentCard,
  data,
  gid,
  isEditBtnShown,
  isReviewMode,
  InfoModalClose,
  isNotInEditMode,
}) => {
  const [isGoingScenarioSetModalOpened, setisGoingScenarioSetModalOpened] =
    useState(false)
  const cardBodyRef = useRef()
  const cardBodyRef2 = useRef()
  const infoCardWrapperRef = useRef()
  const infoCardWrapperRef2 = useRef()

  const {
    state: { isTranslated, langForTransState },
    dispatch,
  } = useContext(DataContext)

  const [translations, settranslations] = useState(null)
  const [originalTitle, setoriginalTitle] = useState(null)

  useEffect(() => {
    const fetcher = async () => {
      const [res1, res2] = await Promise.all([
        (originalTitle || cardBodyRef2?.current) &&
          fetcherAPI.translation(
            'en',
            langForTransState,
            originalTitle ?? cardBodyRef2?.current,
          ),
        fetcherAPI.translation(
          'en',
          langForTransState,
          infoCardWrapperRef2?.current,
        ),
      ])
      settranslations({
        res1,
        res2,
      })
    }
    if (isTranslated && (originalTitle || cardBodyRef2?.current)) {
      fetcher()
    }
  }, [isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    if (!!canEditContentCard && !isTranslated) {
      if (!cardBodyRef2?.current && !!cardBodyRef.current?.innerHTML) {
        cardBodyRef2.current = cardBodyRef.current?.innerHTML
      }
      if (!!cardBodyRef2?.current) {
        setoriginalTitle(cardBodyRef2?.current)
      }

      if (!infoCardWrapperRef2?.current && !!infoCardWrapperRef.current) {
        infoCardWrapperRef2.current = infoCardWrapperRef.current.innerHTML
      }
      // dispatch({
      //   type: ACTIONS.GETWHOLEHTMLCARD3,
      //   payload: true,
      // });
    }
  }, [isTranslated, canEditContentCard, dispatch])

  return (
    <>
      <WarningEditModal
        InfoModalHeader={`Going to ${data?.scenarioSet?.title} (scenario set) page`}
        // InfoModalDescription1={'Please note,'}
        // // InfoModalDescription2={
        // //   'that editing the axis will reset the perspectives, which affects to all 4 scenarios attached to this scenario set.'
        // // }
        // InfoModalDescription3={
        //   'that editing the drivers will affect all scenario cards that are created with this scenario set. New drivers become visible on all scenario cards.'
        // }
        InfoModalDescription4={
          'Are you sure you want to leave this page without saving edits?'
        }
        InfoModalOpen={isGoingScenarioSetModalOpened}
        InfoModalClose={() => {
          setisGoingScenarioSetModalOpened(false)
        }}
        openingFieldEditingModalHandler={() => {
          // setisGoingScenarioSetModalOpened(false)
          window.open(
            `/scenario?gid=${gid}&scenario-set-id=${data?.scenarioSet?.id}`,
          )
        }}
      />
      <div className={styles.cardFooterWrapper}>
        <>
          {!isTranslated ? (
            <div className={styles.footerText} ref={infoCardWrapperRef}>
              {Number(gid) !== 0 && (
                <div
                  style={{
                    marginBottom: '8px',
                  }}>
                  Scenario set:{' '}
                  <span
                    style={{
                      color: '#0e9beb',
                      cursor: 'pointer',
                    }}>
                    <GoingToScenarioSet
                      onClick={() => {
                        if (!isNotInEditMode) {
                          setisGoingScenarioSetModalOpened(true)
                        } else {
                          window.open(
                            `/scenario?gid=${gid}&scenario-set-id=${data?.scenarioSet?.id}`,
                          )
                        }
                      }}>
                      {' '}
                      {data?.scenarioSet?.title}{' '}
                    </GoingToScenarioSet>
                  </span>
                  <GoingToScenarioSet
                    style={{
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      if (!isNotInEditMode) {
                        setisGoingScenarioSetModalOpened(true)
                      } else {
                        window.open(
                          `/scenario?gid=${gid}&scenario-set-id=${data?.scenarioSet?.id}`,
                        )
                      }
                    }}>
                    (link)
                  </GoingToScenarioSet>
                </div>
              )}
              {Number(gid) !== 0 && (
                <div
                  style={{
                    marginBottom: '8px',
                  }}>
                  Scenario type:{' '}
                  <span>
                    {data?.scenarioSet?.type === 'futures_table'
                      ? 'Futures Table'
                      : '2x2 (Drivers of uncertainty)'}
                  </span>
                </div>
              )}
              {Number(gid) === 0 && (
                <div
                  style={{
                    marginBottom: '8px',
                  }}>
                  Scenario type: <span>FP Scenario card</span>
                </div>
              )}
            </div>
          ) : (
            <div
              dangerouslySetInnerHTML={{
                __html: translations?.res2?.data,
              }}
              className={styles.footerText}
              ref={infoCardWrapperRef}></div>
          )}
        </>
        {((!!canEditContentCard && !!isEditBtnShown) || !!isReviewMode) && (
          <div
            style={{
              marginTop: '29px',
              display: 'flex',
              justifyContent: !!isReviewMode ? 'flex-end' : 'flex-start',
            }}>
            <button
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
              }}
              className={
                styles.editScenarioCardBtn +
                ' btn btn-sm btn-outline-secondary '
              }
              onClick={!isReviewMode ? onOpenPhenEditCard : InfoModalClose}>
              <span
                className={clsx(styles.pencilIcon, 'af-custom-edit')}></span>
              {!isTranslated ? (
                <div ref={cardBodyRef}>
                  {!!isReviewMode ? 'CLOSE THE PREVIEW' : 'EDIT SCENARIO'}
                </div>
              ) : (
                <div
                  ref={cardBodyRef}
                  dangerouslySetInnerHTML={{
                    __html: translations?.res1?.data,
                  }}></div>
              )}
            </button>
          </div>
        )}
      </div>
    </>
  )
}

export default CardFooter

const GoingToScenarioSet = styled.a`
  &:hover {
    text-decoration: underline !important;
  }
`
